import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	agentNotifications: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.notifications.agent-notifications',
		defaultMessage: 'Internal notifications',
		description: 'Settings navigation menu link for a service project',
	},
	customerNotifications: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.notifications.customer-notifications',
		defaultMessage: 'Customer notifications',
		description: 'Settings navigation menu link for a service project',
	},
});
